import { InstitutionService } from './../../../services/institution.service';
import { Component, OnInit } from '@angular/core';
import { EditInstitutionModel } from '../../../models/inModels/Institution';
import { Message } from 'primeng/primeng';
import { ActivatedRoute, Router } from '@angular/router';
import { InterestsService } from '../../../services/business/interests.service';
import { StorageService } from '../../../services/system/storage.service';

@Component({
  selector: 'app-edit-institution',
  templateUrl: './edit-institution.component.html',
  styleUrls: ['./edit-institution.component.css']
})
export class EditInstitutionComponent implements OnInit {
  id;
  model: EditInstitutionModel;
	loading = false;
	error: Message[];
  uploading = false;
  institutions;
  constructor(
    private route: ActivatedRoute,
		private router: Router,
		private institutionService: InstitutionService,
		private storageService: StorageService
  ) { 
    this.id = this.route.snapshot.paramMap.get('Id');
  }

  ngOnInit() {
    this.getInstitution();
  }

  getInstitution() {
    this.loading = true;
    this.institutionService.get(this.id).then(
      result => {
        this.model = new EditInstitutionModel(result)
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }
  goBack(): void {
		this.router.navigate(['institutions']);
  }

  save() {
		this.loading = true;
		this.institutionService.update(this.model).then(
			result => {
				this.loading = false;
				this.model = new EditInstitutionModel(result);
				this.error = [];
				this.error.push({ severity: 'success', summary: 'Success', detail: "Institution saved" });
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
  }

  handleImage(event): void {
		var result = this.storageService.handleSuccess(event);

		this.model.logoId = result.PublicId;
		this.loading = false;
  }
  
  handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
  }
  
  removeImage(): void {
		this.model.logoId = null;
		this.loading = false;
	}

}



// WEBPACK FOOTER //
// ./src/app/components/institutions/edit-institution/edit-institution.component.ts